<script>
  import { checkbox } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';
  import linguagens from '~js/linguagens';
  import DadosAdicionaisDoacoesTraducao from './FormDadosAdicionaisDoacoesTraducao.vue';
  import DadosAdicionaisTraducao from './FormDadosAdicionaisTraducao.vue';
  import solicitacaoCursoEventoServicoServico from '~modulos/solicitacao-curso-evento-servico/servico';

  export default {
    components: { checkbox, Radio, DadosAdicionaisDoacoesTraducao, DadosAdicionaisTraducao },
    props: {
      solicitacao: Object,
      edicao: Boolean
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        linguagens: linguagens,

        carregandoTraducoes: false,
        aceiteInstrucoes: null
      }
    },
    computed: {
        labelDoacaoInscricao(){
            if (this.solicitacao.tipoSolicitacao == 4) {
                return "doação";
            }

            return "inscrição";
        }
    },
    methods: {
      camposTraducao(idLinguagem){
            return {
                "idSolicitacaoCursoEventoServicoTraducoes": null,
                "idSolicitacaoCursoEventoServico": null,
                "idLinguagem": idLinguagem,
                "descricao": null,
                "resumo": null,
                "descricaoDoacao": null,
                "mensagemFinalSalvar": null,
                "informacoes": null,
                "observacoes": null,
                "justificativa": null,
                "objetivos": null,
                "metodologia": null,
                "infraestrutura": null,
                "ementaDisciplina": null,
                "investimento": null,
                "local": null,
                "outrasInformacoes": null,
                "duracao": null,
                "areaConhecimento": null,
                "preRequisito": null,
                "publicoAlvo": null,
                "formaPagamento": null,
                "devolucaoInscricao": null
            }
      },
      validarDadosSolicitacao(valido) {
          if (!valido) throw new Error("validacao com erro");

          let validoTraducao = true;
          let msgErro = "";

          if (this.solicitacao.permitirEstrangeiro == 1) {
              for (let index = 0; index < this.solicitacao.solicitacaoCursoEventoServicoTraducoes.length; index++) {
                var id = this.solicitacao.solicitacaoCursoEventoServicoTraducoes[index].idLinguagem;
                var traducao = this.solicitacao.solicitacaoCursoEventoServicoTraducoes[index];

                if (id == 1) 
                    continue;

                if (this.solicitacao.tipoSolicitacao == 4) {
                    this.$refs.dadosAdicionaisDoacoesTraducao[index - 1].$validator.validateAll()
                   
                    if (!traducao.descricao)  
                    {
                        $('#tabs a[href="' + '#tab-traducao-' + id + '"]').tab('show');
                        $('#tabs a[href="#tab-internacionalizacao"]').tab('show'); 
                        validoTraducao = false;
                        msgErro = `Há campos que são obrigatórios e não foram prenchidos, por favor confira os campos em vermelho.`;
                        break;
                    }

                    if (!traducao.resumo)  
                    {
                        $('#tabs a[href="' + '#tab-traducao-' + id + '"]').tab('show');
                        $('#tabs a[href="#tab-internacionalizacao"]').tab('show'); 
                        validoTraducao = false;
                        msgErro = `Há campos que são obrigatórios e não foram prenchidos, por favor confira os campos em vermelho.`;
                        break;
                    }
                }
                else {
                    this.$refs.dadosAdicionaisTraducao[index - 1].$validator.validateAll()
                    
                    if (!traducao.descricao)  
                    {
                        $('#tabs a[href="' + '#tab-traducao-' + id + '"]').tab('show');
                        $('#tabs a[href="#tab-internacionalizacao"]').tab('show'); 
                        validoTraducao = false;
                        msgErro = `Há campos que são obrigatórios e não foram prenchidos, por favor confira os campos em vermelho.`;
                        break;
                    }

                    if (!traducao.resumo)  
                    {
                        $('#tabs a[href="' + '#tab-traducao-' + id + '"]').tab('show');
                        $('#tabs a[href="#tab-internacionalizacao"]').tab('show'); 
                        validoTraducao = false;
                        msgErro = `Há campos que são obrigatórios e não foram prenchidos, por favor confira os campos em vermelho.`;
                        break;
                    }
                }                
              }

              if (msgErro) {
                    this.$swal(
                    '',
                    msgErro,
                    'info'
                    );

                    throw new Error("validacao");
                    return false;
                }
            }
            else 
                validoTraducao = true;
         
        return validoTraducao && valido;
      },
      retornaLingua(idLingua) {
        return this.linguagens.filter(l => l.id == idLingua)[0].nome;
      },
      linguagemAdicionaRemova(idLingua, value){
        if (value) {
          this.solicitacao.solicitacaoCursoEventoServicoTraducoes.push(this.camposTraducao(idLingua))
        }
        else {
          if (this.solicitacao.solicitacaoCursoEventoServicoTraducoes.length > 0) {
            let id = this.solicitacao.solicitacaoCursoEventoServicoTraducoes.filter(l => (l.idLinguagem != 1))[0].idLinguagem;

            $('#tabsTraducoes a[href="' + '#tab-traducao-' + id + '"]').tab('show');
            $('#tabsTraducoes a[href="' + '#tab-traducao-' + id + '"]').trigger('click');
          }

          this.$set(this.solicitacao, "solicitacaoCursoEventoServicoTraducoes", this.solicitacao.solicitacaoCursoEventoServicoTraducoes.filter(l => l.idLinguagem != idLingua));
        }
      },
      limparCamposEstrangeiro(){
        if (!this.solicitacao.permitirEstrangeiro){
            this.solicitacao.traduzirIngles = null;
            this.solicitacao.traduzirEspanhol = null;
            this.solicitacao.traduzirFrances = null;
            this.solicitacao.traduzirItaliano = null;
            this.aceiteInstrucoes = null;
            
            this.solicitacao.solicitacaoCursoEventoServicoTraducoes =
                this.solicitacao.solicitacaoCursoEventoServicoTraducoes.filter(l => l.idLinguagem == 1);
        }
      },
      traduzirTextos(){
          var objetoTraducao = this.camposTraducao(1);
          
          objetoTraducao.descricao = this.solicitacao.descricao;
          objetoTraducao.resumo = this.solicitacao.resumo;
          objetoTraducao.mensagemFinalSalvar = this.solicitacao.mensagemFinalSalvar;
          objetoTraducao.permitirEstrangeiro = this.solicitacao.permitirEstrangeiro == 1;
          objetoTraducao.traduzirIngles = this.solicitacao.traduzirIngles;
          objetoTraducao.traduzirEspanhol = this.solicitacao.traduzirEspanhol;
          objetoTraducao.traduzirFrances = this.solicitacao.traduzirFrances;
          objetoTraducao.traduzirItaliano = this.solicitacao.traduzirItaliano;

          if (this.solicitacao.tipoSolicitacao == 4) {
            objetoTraducao.descricaoDoacao = this.solicitacao.solicitacaoDoacao[0].descricaoDoacao;
          }
          else {
            objetoTraducao.informacoes = this.solicitacao.solicitacaoCursoEventos[0].informacoes;
            objetoTraducao.observacoes = this.solicitacao.solicitacaoCursoEventos[0].observacoes;
            objetoTraducao.justificativa = this.solicitacao.solicitacaoCursoEventos[0].justificativa;
            objetoTraducao.objetivos = this.solicitacao.solicitacaoCursoEventos[0].objetivos;
            objetoTraducao.metodologia = this.solicitacao.solicitacaoCursoEventos[0].metodologia;
            objetoTraducao.infraestrutura = this.solicitacao.solicitacaoCursoEventos[0].infraestrutura;
            objetoTraducao.ementaDisciplina = this.solicitacao.solicitacaoCursoEventos[0].ementaDisciplina;
            objetoTraducao.investimento = this.solicitacao.solicitacaoCursoEventos[0].investimento;
            objetoTraducao.local = this.solicitacao.solicitacaoCursoEventos[0].local;
            objetoTraducao.outrasInformacoes = this.solicitacao.solicitacaoCursoEventos[0].outrasInformacoes;
            objetoTraducao.duracao = this.solicitacao.solicitacaoCursoEventos[0].duracao;
            objetoTraducao.areaConhecimento = this.solicitacao.solicitacaoCursoEventos[0].areaConhecimento;
            objetoTraducao.preRequisito = this.solicitacao.solicitacaoCursoEventos[0].preRequisito;
            objetoTraducao.publicoAlvo = this.solicitacao.solicitacaoCursoEventos[0].publicoAlvo;
            objetoTraducao.formaPagamento = this.solicitacao.solicitacaoCursoEventos[0].formaPagamento;
            objetoTraducao.devolucaoInscricao = this.solicitacao.solicitacaoCursoEventos[0].devolucaoInscricao;
          }

          $('#traduzir').button('loading');

          solicitacaoCursoEventoServicoServico
            .traduzir(objetoTraducao, this.solicitacao.tipoSolicitacao)
            .then(textosTraduzidos => {
               
                this.solicitacao.solicitacaoCursoEventoServicoTraducoes = this.solicitacao.solicitacaoCursoEventoServicoTraducoes.filter(l => l.idLinguagem == 1);

                for (let index = 0; index < textosTraduzidos.length; index++) {
                    this.solicitacao.solicitacaoCursoEventoServicoTraducoes.push(textosTraduzidos[index]);
                }

                $('#traduzir').button('reset');
                this.carregandoTraducoes = false;
            })
            .catch(error => {
                $('#traduzir').button('reset');
                this.carregandoTraducoes = false;
                this.$mensagemErro(error, 'Erro ao conectar serviço de tradução.');
            });
      }
    },
    mounted() {

    },
    watch: 
    {
        'solicitacao.permitirEstrangeiro': 'limparCamposEstrangeiro',
    }
  }
</script>

<style scoped>
  .infoSol {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>
    <div>
        <div class="row">
            <div class="col-sm-2">
                <div class="required">
                    <label class="control-label" for="permitirEstrangeiro">Permitir estrangeiros <i class="fa fa-info-circle infoSol" v-tooltip="'Se SIM, será permitido inscrições\\doações de pessoas estrangeiras sem CPF.'"></i></label>
                </div>

                <div class="form-group required">
                    <radio v-model="solicitacao.permitirEstrangeiro"
                           :selected-value="1"
                           type="success"
                           :inline="true"
                           data-vv-name="permitirEstrangeiro"
                           name="permitirEstrangeiro"
                           class="margin-right-10"
                           :class="[true ? '' : 'radioLeft']">
                        Sim
                    </radio>
                    <radio v-model="solicitacao.permitirEstrangeiro"
                           :selected-value="0"
                           data-vv-name="permitirEstrangeiro"
                           name="permitirEstrangeiro"
                           type="success"
                           :inline="true">
                        Não
                    </radio>
                </div>
            </div>

            <div class="col-xs-2" v-if="solicitacao.permitirEstrangeiro" style="margin-top: 24px;">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox v-model="solicitacao.traduzirIngles" value="1" type="primary" @checked="linguagemAdicionaRemova(2, $event)">
                            Traduzir para Inglês
                        </checkbox>
                    </div>
                </div>
            </div>

            <div class="col-xs-2" v-if="solicitacao.permitirEstrangeiro" style="margin-top: 24px;">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox v-model="solicitacao.traduzirEspanhol" value="1" type="primary" @checked="linguagemAdicionaRemova(3, $event)">
                            Traduzir para Espanhol
                        </checkbox>
                    </div>
                </div>
            </div>

            <div class="col-xs-2" v-if="solicitacao.permitirEstrangeiro" style="margin-top: 24px;">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox v-model="solicitacao.traduzirFrances" value="1" type="primary" @checked="linguagemAdicionaRemova(4, $event)">
                            Traduzir para Francês
                        </checkbox>
                    </div>
                </div>
            </div>

            <div class="col-xs-2" v-if="solicitacao.permitirEstrangeiro" style="margin-top: 24px;">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox v-model="solicitacao.traduzirItaliano" value="1" type="primary" @checked="linguagemAdicionaRemova(5, $event)">
                            Traduzir para Italiano
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="solicitacao.permitirEstrangeiro && configuracao.habilitarGoogleTranslateCoordenador">
            <div class="hr-line-dashed margin-top-5"></div>

            <h3 class="m-t-none m-b">Instruções</h3>

            <div class="row">
                <ul>
                    <li>Selecione 'SIM' no campo 'Permitir estrangeiros' se deseja receber {{labelDoacaoInscricao}} de pessoas estrangeiras sem CPF.</li>
                    <li>Preencha os dados da solicitação antes de executar a tradução automática.</li>
                    <li>Selecione todas as línguas desejadas para a tradução.</li>
                    <li>Os dados das guias abaixo serão sobrescritos após a execução do processo de tradução automática.</li>
                    <li>Será utilizada a tradução automática do sistema do Google Tradutor.</li>
                    <li>Após o processo de tradução automática, revise todos os dados.</li>
                    <li>Este recurso está em fase experimental e pode apresentar erros.</li>
                </ul>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <div class="row" style="margin-top: 24px;">
                <div class="col-xs-2">
                    <div class="form-group">
                        <div class="checkbox">
                            <checkbox v-model="aceiteInstrucoes" value="1" type="primary">
                                Li as intruções acima
                            </checkbox>
                        </div>
                    </div>
                </div>

                <div class="col-xs-10">
                    <div class="form-group">
                        <button id="traduzir"
                                type="button"
                                class="btn btn-primary"
                                @click="traduzirTextos"
                                :disabled="!aceiteInstrucoes"
                                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
                            <i class="fa fa-language"></i>
                            Tradução automática
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="hr-line-dashed margin-top-5" v-if="solicitacao.solicitacaoCursoEventoServicoTraducoes.length > 1"></div>

        <div class="wrapper wrapper-content" v-if="solicitacao.solicitacaoCursoEventoServicoTraducoes.length > 1">
            <div class="row">
                <div class="col-xs-12">
                    <div class="tabs-container" id="tabsTraducoes">

                        <ul class="nav nav-tabs">
                            <li :class="{active : index == 1}" :id="'tab-traducao-li-' + traducao.idLinguagem" v-if="traducao.idLinguagem != 1" v-for="(traducao, index) in solicitacao.solicitacaoCursoEventoServicoTraducoes">
                                <a data-toggle="tab"
                                   :href="'#tab-traducao-' + traducao.idLinguagem">
                                    {{retornaLingua(traducao.idLinguagem)}}
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content">
                            <div :class="{active : index == 1}" v-if="traducao.idLinguagem != 1" :id="'tab-traducao-' + traducao.idLinguagem" class="tab-pane" v-for="(traducao, index) in solicitacao.solicitacaoCursoEventoServicoTraducoes">
                                <div class="panel-body">
                                    <dados-adicionais-doacoes-traducao v-if="solicitacao.tipoSolicitacao == 4"
                                                                       ref="dadosAdicionaisDoacoesTraducao"
                                                                       :solicitacao="solicitacao"
                                                                       :solicitacaoTraducao="solicitacao.solicitacaoCursoEventoServicoTraducoes[index]"
                                                                       :carregandoTraducoes="carregandoTraducoes">
                                    </dados-adicionais-doacoes-traducao>

                                    <dados-adicionais-traducao v-if="solicitacao.tipoSolicitacao != 4"
                                                               ref="dadosAdicionaisTraducao"
                                                               :solicitacao="solicitacao"
                                                               :solicitacaoTraducao="solicitacao.solicitacaoCursoEventoServicoTraducoes[index]"
                                                               :carregandoTraducoes="carregandoTraducoes">
                                    </dados-adicionais-traducao>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormInternacionalizacao.vue